var map = {
	"./cHeads1.jpg": 7088,
	"./cHeads2.jpg": 3829,
	"./cHeads3.jpg": 5617,
	"assets/collections/editorials/C-Heads Magazine/cHeads1.jpg": 7088,
	"assets/collections/editorials/C-Heads Magazine/cHeads2.jpg": 3829,
	"assets/collections/editorials/C-Heads Magazine/cHeads3.jpg": 5617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855;